import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcControlsWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderControls();
}
